"use strict";

/**
* Реквизит типа «Строка» и «Многострочный текст».
* 
* @class WebAccess.components.wrappers.form.requisites.Text
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {object} data Данные для инициализации реквизита
* @since 5.0.0.7100
*/
(function (global) {

  var Text = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "Text",

    /**   
    * Получить значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Text#getValue
    * @return {string} Строка, содержащая значение реквизита.
    * @since 5.0.0.7100
    */
    getValue: function (opt_jControl) {
      if (this._data && this._data.isRendered === false) return this._data.value;

      var jControl = opt_jControl || this.controls[0];
      if (typeof jControl.data('autoNumeric') === 'object') {
        return jControl.autoNumeric('get');
      }
      return (!jControl.val()) ? null : jControl.val();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**   
    * Получить отображаемое значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Text#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      return this.getValue(opt_jControl);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**   
    * Установить значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Text#setValue
    * @param value {string} Устанавливаемое значение реквизита
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Text} Текущий объект реквизита – Text.
    * @since 5.0.0.7100
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {      
      opt_needTriggerResult = (opt_needTriggerResult !== false);
      const newValue = opt_displayValue || value;

      if (!this.controls.length) {
        return this._setInvisibleValues(newValue, opt_displayValue, opt_needTriggerResult);
      }

      for (const jControl of this.controls) {
        jControl.val(newValue);
        if (opt_needTriggerResult) {
          jControl.change();
        }
        if (!jControl.is('textarea')) {
          jControl.attr('title', newValue);
        }
        //Если на строковом реквизите есть пользовательский выбор, то значение в контроле отображается неполностью.
        const requisiteReferenceInstance = jControl.data('ReferenceSelectInstance');
        if (requisiteReferenceInstance && requisiteReferenceInstance.isCustomSelect) {
          requisiteReferenceInstance.changeInpWidthAndPadding();
        }
      }

      this.touch();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**   
    * Установить отображаемое значение реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Text#setDisplayValue
    * @param value {string} Устанавливаемое значение реквизита
    * @return {WebAccess.components.wrappers.form.requisites.Text} Текущий объект реквизита – Text.
    * @since 5.0.0.7100
    */
    setDisplayValue: function (value) {
      this.setValue(value);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Получить контролы реквизита
    *
    * @method WebAccess.components.wrappers.form.requisites.BaseRequisite#_bindEvents
    * @since 5.0.0.7100
    * @private
    * @return {array} список jquery объектов
    */
    _getControls: function () {
      var me = this;
      var res = [];
      var jControl;

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];
        jControl = $('input#' + id + ',textarea#' + id);
        if (jControl.length) {
          res.push(jControl);
        }
      };
      return res;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.WA.CMP.wrappers.form.requisites.Text = Text;
})(window);